import React, { lazy, Suspense } from 'react';
import DashboardStats from '../components/DashboardStats';
import { useAuth } from '../contexts/AuthContext';
import { Building2, Activity, ArrowRightLeft, Users } from 'lucide-react';

const Map = lazy(() => import('../components/Map'));

const Home = () => {
  const { user } = useAuth();

  return (
    <div className="page-container">
      <div className="bg-white rounded-lg shadow-lg p-6 mb-8">
        <h2 className="text-2xl font-bold mb-2">مرحباً {user?.full_name}</h2>
        <p className="text-gray-600 mb-6">بوابة تحديث التخصصات الطبية للمستشفيات</p>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-8">
          <div className="space-y-4">
            <h3 className="text-lg font-semibold text-primary flex items-center gap-2">
              <Activity className="h-5 w-5" />
              نظرة عامة
            </h3>
            <p className="text-gray-600">
              منصة متكاملة تهدف إلى تحسين كفاءة وفعالية نظام الإحالات الطبية في المملكة العربية السعودية من خلال توفير نظام موحد لإدارة وتتبع التخصصات الطبية المتاحة في جميع المستشفيات.
            </p>
          </div>

          <div className="space-y-4">
            <h3 className="text-lg font-semibold text-primary flex items-center gap-2">
              <ArrowRightLeft className="h-5 w-5" />
              الأهداف الرئيسية
            </h3>
            <ul className="space-y-2 text-gray-600">
              <li className="flex items-center gap-2">
                <Building2 className="h-4 w-4 text-primary flex-shrink-0" />
                تسهيل عملية إحالة المرضى بين المرافق الصحية
              </li>
              <li className="flex items-center gap-2">
                <Users className="h-4 w-4 text-primary flex-shrink-0" />
                تحسين تجربة المرضى وتقليل وقت الانتظار
              </li>
              <li className="flex items-center gap-2">
                <Activity className="h-4 w-4 text-primary flex-shrink-0" />
                رفع كفاءة استخدام الموارد الطبية المتاحة
              </li>
            </ul>
          </div>
        </div>

        <div className="bg-green-50 p-4 rounded-lg">
          <h3 className="text-lg font-semibold text-primary mb-3">المميزات الرئيسية</h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <div className="bg-white p-4 rounded-lg shadow-sm">
              <h4 className="font-semibold text-gray-800 mb-2">تحديث مباشر</h4>
              <p className="text-sm text-gray-600">
                تحديث فوري لحالة التخصصات والخدمات المتوفرة في كل مستشفى
              </p>
            </div>
            <div className="bg-white p-4 rounded-lg shadow-sm">
              <h4 className="font-semibold text-gray-800 mb-2">تتبع الإحالات</h4>
              <p className="text-sm text-gray-600">
                نظام متكامل لتتبع وإدارة الإحالات الطبية بين المستشفيات
              </p>
            </div>
            <div className="bg-white p-4 rounded-lg shadow-sm">
              <h4 className="font-semibold text-gray-800 mb-2">تقارير تفصيلية</h4>
              <p className="text-sm text-gray-600">
                إحصائيات ومؤشرات أداء شاملة لدعم اتخاذ القرار
              </p>
            </div>
          </div>
        </div>
      </div>
      
      <DashboardStats />
      
      <Suspense fallback={
        <div className="h-[500px] flex items-center justify-center bg-white rounded-lg shadow-lg">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
        </div>
      }>
        <Map />
      </Suspense>
    </div>
  );
};

export default Home;